import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import "./ChatUserModal.css";
import HashLoader from "react-spinners/HashLoader";
import { getColorFromName } from "../../utils/getColor";
import apiServiceHandler from "../../service/apiService";
import { useDispatch } from "react-redux";
import { clearNotification, updateChatMembers, updateNewChat } from "../../redux/chatData";
import { CirclePlus, Trash } from "lucide-react";

import {
  doc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";

import { firestore } from "../../firebase";
const headers = ["USER", "EMAIL", "DIRECT MESSAGE", "CREATE GROUP"];

const ChatUserModal = ({ isOpen, onClose }) => {
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(0);
  const [noMorePosts, setNoMorePosts] = useState(false);
  const limit = 10;
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const isAdmin = userDetails?.admin;
  const dispatch = useDispatch()
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("")

  const getAllUsers = async (pageNum = 0) => {
    try {
      setLoading(pageNum === 0);
      setLoadingMore(pageNum > 0);
      let apiUrl = `api/chat/new/conversation?page=${pageNum}&offset=${limit}`;
      if (searchQuery) {
        apiUrl += `&search=${searchQuery}`;
      }
      const response = await apiServiceHandler(
        "GET",
        apiUrl,
        {}
      );
      if (pageNum === 0) {
        setAllUsers(response.data);
        setNoMorePosts(false);
      } else {
        if (response.data.length < limit) {
          setNoMorePosts(true);
        }
        setAllUsers((prevUsers) => [...prevUsers, ...response.data]);
      }
    } catch (error) {
      console.error("Error getting users:", error);
      setLoading(false);
    } finally {
      if (pageNum == 0) {
        setLoading(false);
      }
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, [isOpen, searchQuery]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getAllUsers(nextPage);
  };

  const closeModal = () => {
    setPage(0)
    setSearchQuery("")
    onClose()
    setSelectedMembers([])
  }

  const startNewChat = async (id) => {
    const payload = {
      partnerUserId: [id],
    };

    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "POST",
        "api/chat/add/conversation",
        payload
      );

      if (response.status) {
        setLoading(false)
        closeModal()
      }

      const groupRef = doc(firestore, "group", response.data._id);

      await setDoc(
        groupRef,
        {
          lastMessageTimestamp: serverTimestamp(),
        },
        { merge: true }
      );
      dispatch(updateNewChat(true))

    } catch (error) {
      console.error("Error getting users:", error);
      setLoading(false);
    }
  };

  const handleCreateGroupChat = async () => {
    try {
      setLoading(true);
      const payload = {
        partnerUserId: selectedMembers,
      };
      const response = await apiServiceHandler(
        "POST",
        "api/chat/add/conversation",
        payload
      );
      // console.log(response, 'res is here group chat');
      if (response.status) {
        setLoading(false)
        dispatch(updateNewChat(true))
        closeModal()

        const groupRef = doc(firestore, "group", response.data._id);

        await setDoc(
          groupRef,
          {
            lastMessageTimestamp: serverTimestamp(),
          },
          { merge: true }
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error creating group chat:", error);
    }
  };

  const toggleMemberSelection = (id) => {
    if (selectedMembers.includes(id)) {
      // Remove the member
      setSelectedMembers((prev) => prev.filter((memberId) => memberId !== id));
    } else {
      // Add the member
      setSelectedMembers((prev) => [...prev, id]);
    }
  };

  return (
    <Modal show={isOpen} onHide={closeModal} centered size="xl" className="w-100">
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>{isAdmin ? "New Chat" : "Chat with Admins"}</Modal.Title>
        <div className="chat-modal-search-field" style={isAdmin ? { marginLeft: '38rem' } : { marginLeft: '34rem' }}>
          <div className="text-input-wrapper">
            <input
              type="text"
              className="text-input"
              placeholder="search by name, email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="icon">{/* Your Search Icon Here */}</span>
          </div>
          {selectedMembers.length > 0 && (
            <button
              className="invite-btn"
              onClick={() => handleCreateGroupChat()}>
              {/*
            <span class="icon-plus">
              <PlusIcon />
            </span>
            */}
              <span class="invite-btn-label">Create Group</span>
            </button>)}
        </div>
      </Modal.Header>

      <Modal.Body>
        <div
          className="members-data-table"
          style={{
            maxHeight: "75vh",
            overflowY: "scroll",
            scrollBehavior: "smooth",
          }}
        >
          <div className="members-data-table__table">
            <div className="members-data-table__header">
              {headers.map((header) => (
                <div className="data-table__header-cell" key={header}>
                  <div style={{ display: "flex" }}>
                    <span className="header-text-label">{header}</span>
                  </div>
                </div>
              ))}
            </div>

            {!loading ? (
              allUsers && allUsers.length > 0 ? (
                <>
                  {allUsers.map((user, index) => (
                    <div className="members-data-table__body" key={index}>
                      <div
                        className={`members-data-table__row-${index % 2 === 0 ? "odd" : "even"
                          }`}
                      >
                        <div className="member-data-table__cell--name">
                          <div className="data-table__cell-body">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="member-avatar"
                                style={{
                                  backgroundColor: getColorFromName(user.name),
                                }}
                              >
                                <div className="member-avatar__text">
                                  {user && user.image ? (
                                    <img
                                      className="avatar__image"
                                      src={user.image}
                                      alt="User Avatar"
                                    />
                                  ) : (
                                    <div className="user__avatar">
                                      {user?.name.substr(0, 1)}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <span style={{ marginLeft: "1rem" }}>
                                {user.name}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--email">
                          <div className="member-data-table__cell-body">
                            <div className="member__email">{user.email}</div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--actions">
                          <div className="member-data-table__cell-body">
                            <button className="add__members" onClick={() => startNewChat(user._id)}>
                              <svg
                                viewBox="0 0 20 20"
                                fill="#d1b794"
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon__svg"
                                preserveAspectRatio="xMidYMid meet"
                                style={{ width: "20px", height: "20px" }}
                              >
                                <path d="M3.25 0A3.254 3.254 0 000 3.25v11.018a1.246 1.246 0 001.251 1.25c.259 0 .516-.08.734-.239L6.493 12h6.257A3.254 3.254 0 0016 8.75v-5.5A3.254 3.254 0 0012.75 0h-9.5zM17 4.01v4.74A4.253 4.253 0 0112.75 13H6.82l-2.225 1.615A3.245 3.245 0 007.25 16h6.255l4.51 3.28a1.242 1.242 0 001.3.1c.425-.21.685-.64.685-1.11V7.25a3.258 3.258 0 00-3-3.24z"></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="member-data-table__cell--actions">
                          <div className="member-data-table__cell-body">
                            {userDetails?.admin &&
                              userDetails?._id !== user?._id &&
                              (
                                selectedMembers.includes(user._id) ? (
                                  <button
                                    className="add__members"
                                    onClick={() => toggleMemberSelection(user._id)}
                                  >
                                    <Trash
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        color: "red",
                                      }}
                                    />
                                  </button>
                                ) : (
                                  <button
                                    className="add__members"
                                    onClick={() => toggleMemberSelection(user._id)}
                                  >
                                    <CirclePlus
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        color: "#d1b794",
                                      }}
                                    />
                                  </button>
                                )
                              )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {!noMorePosts ? (
                    <button
                      onClick={handleLoadMore}
                      disabled={loadingMore}
                      className="load-more-chat-users-btn"
                    >
                      {loadingMore ? (
                        <div className="chat-loader">
                          <HashLoader color="#d1b794" size={20} />
                          <p>Loading more users</p>
                        </div>
                      ) : (
                        <span style={{ marginTop: "1rem" }}>
                          Load more users
                        </span>
                      )}
                    </button>
                  ) : (
                    <p
                      className="load-more-users-btn"
                      style={{
                        color: "#000",
                        position: "relative",
                        left: "110%",
                      }}
                    >
                      No More Users.
                    </p>
                  )}
                </>
              ) : (
                <div
                  style={{
                    position: "relative",
                    left: "100%",
                    marginTop: "1rem",
                  }}
                >
                  No Users Found.
                </div>
              )
            ) : (
              <div
                className="member-loader"
                style={{
                  position: "relative",
                  left: "65%",
                  marginTop: "1rem",
                }}
              >
                <HashLoader color="#d1b794" size={20} />
                <p>Loading Users</p>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChatUserModal;
